import styled, { css } from 'styled-components';

import VacationOptions from '@lt/components/icons-react/VacationOptions';
import CalendarDay from '@lt/components/icons-react/userflow/CalendarDay';

const datePickerOptionStyles = css`
  width: 16px;
  height: 16px;
`;

const VacationOptionsIcon = styled(VacationOptions)<{ $isSelected: boolean }>`
  ${datePickerOptionStyles}

  & path {
    fill: ${({ $isSelected }) => ($isSelected ? '#17181a' : '#4d4d4d')};
  }
`;

const CalendarDayIcon = styled(CalendarDay)<{ $isSelected: boolean }>`
  ${datePickerOptionStyles}

  & path {
    stroke: ${({ $isSelected }) => ($isSelected ? '#17181a' : '#4d4d4d')};
  }
`;

export const DATE_PICKER_OPTION_NAME_TO_ICON = {
  concrete_dates: CalendarDayIcon,
  vacation_options: VacationOptionsIcon,
};

export const DATE_PICKER_OPTION_NAMES = {
  CONCRETE_DATES: 'concrete_dates',
  VACATION_OPTIONS: 'vacation_options',
} as const;

export const tabs = [
  {
    id: DATE_PICKER_OPTION_NAMES.CONCRETE_DATES,
    text: 'Точные даты',
  },
  {
    id: DATE_PICKER_OPTION_NAMES.VACATION_OPTIONS,
    text: 'Гибкие настройки',
  },
];

export type DatePickerTabsNames = 'concrete_dates' | 'vacation_options';
